import React from 'react'
import { useTranslation } from 'react-i18next'
// @ts-ignore
import { Dialog } from '@netbasequid/core'
import { useDisplayTheme } from 'hooks/useUiState'
import { useDeleteDashboard } from '../hooks/useDeleteDashboard'

type DetailProps = {
  dashboardId: string
  open: boolean
  onClose: () => void
}

const DeleteConfirmationDialog = ({ dashboardId, open, onClose }: DetailProps) => {
  const displayTheme = useDisplayTheme()
  const { t } = useTranslation()

  const { handleDelete, isDeleting } = useDeleteDashboard({
    dashboardId
  })

  return (
    <Dialog
      mode={displayTheme}
      open={open}
      onClose={onClose}
      disableEscapeKeyDown={isDeleting}
      disableBackdropClick
      width="700px">
      <Dialog.DialogTitle>{t('confirmation')}</Dialog.DialogTitle>
      <Dialog.DialogContent width="700px">
        {t('dashboardDeleteConfirmationContent')}
      </Dialog.DialogContent>
      <Dialog.DialogActions
        closeButtonProps={{
          children: t('cancel'),
          onClick: onClose,
          disabled: isDeleting
        }}
        okButtonProps={{
          children: t('delete'),
          color: 'secondary',
          onClick: () => {
            handleDelete()
            onClose()
          },
          disabled: isDeleting
        }}
      />
    </Dialog>
  )
}

export default DeleteConfirmationDialog
